module.exports = __webpack_public_path__ + "static/img/luck.356c51f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integral/luck.gif
// module id = UXhL
// module chunks = 1